export const logError = (err: unknown, toConsole = true): void => {
  if (toConsole) console.error(err);
};
